import { createEntityAdapter } from '@ngrx/entity';
import { SocieteTerritoireEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteTerritoireEntityState>;

export const adapter = createEntityAdapter<SocieteTerritoireEntityState>({
  selectId: o => o.idSocieteTerritoire
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeTerritoireFeatureKey = 'societeTerritoire';
